if (typeof boostPFSThemeConfig != "undefined") {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: true,
      openMultiLevelByDefault: [] /* Boost 215702 */,
    },
  };

  (function () {
    BoostPFS.inject(this);
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function (data, index) {
      if (!data) data = this.data;
      if (!index) index = this.index;
      var soldOut = !data.available,
        onSale = data.compare_at_price_min > data.price_min,
        priceVaries = data.price_min != data.price_max,
        images = data.images_info;
      if (images.length == 0) {
        images.push({
          src: boostPFSConfig.general.no_image_url,
          id: data.id,
          width: 480,
          height: 480,
        });
      }

      // Get First Variant (selected_or_first_available_variant)
      var firstVariant = data["variants"][0];
      if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
        var paramVariant = data.variants.filter(function (e) {
          return e.id == Utils.getParam("variant");
        });
        if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
      } else {
        for (var i = 0; i < data["variants"].length; i++) {
          if (data["variants"][i].available) {
            firstVariant = data["variants"][i];
            break;
          }
        }
      }
      // Get Template
      var itemHtml = boostPFSTemplate.productGridItemHtml;

      //Add class
      itemHtml = itemHtml.replace(
        /{{mobile_items_per_row}}/g,
        boostPFSConfig.custom.mobile_items_per_row
      );
      itemHtml = itemHtml.replace(
        /{{tablet_items_per_row}}/g,
        boostPFSConfig.custom.tablet_items_per_row
      );
      itemHtml = itemHtml.replace(
        /{{desktop_items_per_row}}/g,
        boostPFSConfig.custom.desktop_items_per_row
      );
      itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
      itemHtml = itemHtml.replace(
        /{{filter_position_class}}/g,
        boostPFSConfig.custom.filter_position
      );

      //add product type
      itemHtml = itemHtml.replace(/{{product_type}}/g, data.product_type);
      itemHtml = itemHtml.replace(/{{product_handle}}/g, data.handle);

      var has_alternate_image = false;
      if (
        images.length > 1 &&
        boostPFSConfig.custom.hasOwnProperty("product_show_secondary_image") &&
        boostPFSConfig.custom.product_show_secondary_image == true
      ) {
        has_alternate_image = true;
      }
      //var media_aspect_ratio = images[0].width / images[0].height;

      //fixed aspect ratio to 1:1
      var media_aspect_ratio = 1;

      itemHtml = itemHtml.replace(
        /{{padding_bottom}}/g,
        "padding-bottom: " + 100 / media_aspect_ratio + "%;"
      );
      itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio.toFixed(3));

      var sizes0 = "200,400,600,700,800,900,1000,1200,1400,1600";
      var image_url = Utils.optimizeImage(images[0]["src"], "{width}x");
      var image_placeholder = Utils.optimizeImage(images[0]["src"], "600x");
      itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
      itemHtml = itemHtml.replace(/{{image_url_placeholder}}/g, image_placeholder);
      itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
      itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
      var featured_media_url = Utils.optimizeImage(images[0]["src"], "600x");
      itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);

      var alternate_image = "";

      if (has_alternate_image && images.length > 1) {
        var sizes1 = "200,300,400,600,800,900,1000,1200";
        var thumbUrl = Utils.optimizeImage(images[1]["src"], "{width}x");
        alternate_image +=
          '<img class="product-card__image product-card__image--secondary" data-src="' +
          thumbUrl +
          '" data-widths="[' +
          imageSize(sizes1, images[1]) +
          ']"  data-sizes="auto" alt="' +
          data.title +
          '" data-image-id="' +
          images[1].id +
          '">';
      }
      itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

      var product_media1_url = featured_media_url;
      if (images.length > 1) {
        product_media1_url = Utils.optimizeImage(images[1]["src"], "600x");
      }
      itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);

      // Add Label
      itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));
      itemHtml = itemHtml.replace(/{{product_label_images}}/g, buildLabelImages(data));

      // Add main attribute (Always put at the end of this function)
      itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));

      var view_product = boostPFSConfig.custom.use_horizontal
        ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' +
          boostPFSConfig.label.view_product +
          "</a>"
        : "";
      itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

      // Add Reviews
      if (typeof Integration === "undefined" || !Integration.hascompileTemplate("reviews")) {
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
      }
      itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
      itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

      return itemHtml;
    };

    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildClass() {
      return boostPFSConfig.custom.filter_position == "drawer" ? "lap-and-up" : "desk";
    }

    function buildClassHiz() {
      return boostPFSConfig.custom.use_horizontal ? "ProductItem--horizontal" : "";
    }

    function imageSize(sizes, image) {
      if (image) {
        var desired_sizes = sizes.split(",");
        var supported_sizes = "";
        for (var k = 0; k < desired_sizes.length; k++) {
          var size = desired_sizes[k];
          var size_as_int = size * 1;
          if (image.width < size_as_int) {
            break;
          }
          supported_sizes = supported_sizes + size + ",";
        }

        if (supported_sizes == "") supported_sizes = image.width;

        if (!jQ.isNumeric(supported_sizes)) {
          supported_sizes = supported_sizes.split(",").join(",");
          supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(","));
        }
        return supported_sizes;
      } else {
        return "";
      }
    }

    function buildPrice(data) {
      var html = "";
      html += '<div class="price-list price-list--product v-stack gap-1">';

      if (data.tags.includes("no_price")) {
        html +=
          '<span class="h6 productInquiryLink" data-fancybox="dialog" data-src="#productInquireDialog">Please Inquire</span>';
      } else if (!data.available) {
        html += '<span class="h6 text-subdued">Email when available</span>';
      } else if (data.compare_at_price_min > data.price_min) {
        html +=
          '<span class="h4 text-on-sale" data-money-convertible>' +
          Utils.formatMoney(data.price_min) +
          "</span>";
        html +=
          '<span class="h5 text-subdued line-through" data-money-convertible>' +
          Utils.formatMoney(data.compare_at_price_min) +
          "</span>";
      } else if (data.price_min != data.price_max) {
        html +=
          '<span class="h5 text-subdued">' +
          boostPFSConfig.label.from_price_html.replace(
            /{{ price_min }}/g,
            Utils.formatMoney(data.price_min)
          ) +
          "</span>";
      } else {
        html +=
          '<span class="h5 text-subdued" data-money-convertible>' +
          Utils.formatMoney(data.price_min) +
          "</span>";
      }

      if (data.unit_price_measurement) {
        var refValue = data.unit_price_measurement.reference_value;
        var refUnit = data.unit_price_measurement.reference_unit;
        var unitPrice = Utils.formatMoney(data.unit_price);
        html +=
          '<span class="h6 text-subdued">(' +
          unitPrice +
          "/" +
          (refValue != 1 ? refValue : "") +
          refUnit +
          ")</span>";
      }

      html += "</div>";
      return html;
    }

    function buildLabels(data) {
      var html = "";
      var product_labels = "";
      if (boostPFSConfig.custom.show_labels) {
        product_labels = "";
        var tags = data.tags;
        /*
        for (var k = 0; k < tags.length; k++) {
          var tag = tags[k];
          if (tag.indexOf('label') != -1) {
            product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('label:')[1] + '</span>';
            break;
          }
        }
        */
        if (data.available) {
          if (data.compare_at_price_min > data.price_min)
            product_labels +=
              '<span class="ProductItem__Label Heading text-subdued smallcaps">' +
              boostPFSConfig.label.sale +
              "</span>";
        } else {
          product_labels +=
            ' <span class="ProductItem__Label Heading text-subdued smallcaps">' +
            boostPFSConfig.label.sold_out +
            "</span>";
        }

        if (product_labels != "") {
          html += '<div class="ProductItem__LabelList">';
          html += product_labels;
          html += "</div>";
        }
      }

      return html;
    }

    //image labels
    function buildLabelImages(data) {
      var html = "";
      var tags = data.tags;

      var left_image_labels = {
        "label:owc": "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/OWC.png?v=1704192680",
      };
      var right_image_labels = {
        "label:en primeur":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/5_Custom.png?v=1704521657",
        "label:pre-arrival":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/6_Custom.png?v=1704521657",
        "label:375 ml":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/1_Custom.png?v=1704521657",
        "label:magnum":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/2_Custom.png?v=1704521657",
        "label:double magnum":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/3_Custom.png?v=1704521657",
        "label:gift box":
          "https://cdn.shopify.com/s/files/1/0551/4310/4704/files/4_Custom.png?v=1704521657",
      };

      var right_labels_html = "";
      var left_labels_html = "";
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k].toLowerCase();
        if (tag in left_image_labels) {
          left_labels_html += `<img src="${left_image_labels[tag]}" />`;
        }

        if (tag in right_image_labels) {
          right_labels_html += `<img src="${right_image_labels[tag]}" />`;
        }
      }
      if (right_labels_html != "" || left_labels_html != "") {
        html += `<div class="product-item-image-labels-container">
                    <div class="product-item-image-labels-left">
                      ${left_labels_html}
                    </div>
                    <div class="product-item-image-labels-right">
                      ${right_labels_html}
                    </div>
                </div>`;
      }
      return html;
    }

    function buildInfo(data, indx) {
      var html = "";
      if (boostPFSConfig.custom.show_product_info) {
        html += '<div class="v-stack gap-4 justify-items-start">';

        if (boostPFSConfig.custom.show_vendor && data.vendor) {
          html += '<p class="smallcaps text-subdued">' + data.vendor + "</p>";
        }

        let designation = "";
        let ratings_arr = [];
        for (let i = 0; i < data.metafields.length; i++) {
          if (data.metafields[i].key === "designation") {
            designation = " " + data.metafields[i].value;
          }
          if (data.metafields[i].namespace === "ratings") {
            let key = data.metafields[i].key;
            ratings_arr.push({
              key: key.replace("r_", "").toUpperCase(),
              original_key: key,
              value: data.metafields[i].value,
            });
          }
        }

        let title_prefix = "";
        if (data.product_type == "Merchandise") {
          title_prefix = data.vendor + " ";
        }

        html +=
          '<a class="product-title h5" href="{{itemUrl}}">' +
          title_prefix +
          data.title +
          designation +
          "</a>";

        if (ratings_arr.length > 0) {
          html += '<div class="product-critic-ratings h-stack wrap">';
          ratings_arr.forEach(function (rating) {
            html += '<div class="product-rating-item ' + rating.original_key + '">';
            html += '<span class="product-rating-id">' + rating.key + "</span>";
            html += '<span class="product-rating">' + rating.value + "</span>";
            html += "</div>";
          });
          html += "</div>";
        }

        html += "{{itemReviews}}";
        html += buildPrice(data);
        html += "</div>";
      }

      return html;
    }

    function buildSwatch(data, indx) {
      var itemSwatchHtml = "";
      if (boostPFSConfig.custom.show_color_swatch) {
        var color_name = boostPFSConfig.custom.section_id + "-" + data.id + "-" + indx;
        data.options_with_values.forEach(function (option, index) {
          var option_name = option.name.toLowerCase();
          if (
            option_name.indexOf("color") != -1 ||
            option_name.indexOf("colour") != -1 ||
            option_name.indexOf("couleur") != -1
          ) {
            var values = "";
            itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
            var i = 0;
            data.variants.forEach(function (variant) {
              var temp = variant.merged_options.filter(function (obj) {
                obj = obj.toLowerCase();
                if (
                  obj.indexOf("color") != -1 ||
                  obj.indexOf("colour") != -1 ||
                  obj.indexOf("couleur") != -1
                )
                  return obj;
              });
              temp = temp[0].split(":");

              var value = temp[1].toLowerCase();
              if (values.indexOf(value) == -1) {
                values = values + "," + value;
                values = values.split(",");
                var size = "200,400,600,700,800,900,1000,1200";
                var supported_sizes = imageSize(size, variant.image);
                var color_image = Utils.optimizeImage(variant.image);
                var name_color = Utils.slugify(value) + ".png";
                var checked = i == 0 ? "checked=checked" : "";
                var imageInfo = null;
                var image_aspect_ratio = 1;
                imageInfo = data.images_info.find(function (imageOb) {
                  if (imageOb.src == variant.image) {
                    image_aspect_ratio = imageOb.width / imageOb.height;
                    return imageOb;
                  }
                });
                if (!imageInfo) {
                  if (data.images_info.length > 0) {
                    imageInfo = data.images_info[0];
                  } else {
                    imageInfo = {
                      src: boostPFSConfig.general.no_image_url,
                      id: variant.id,
                      width: 480,
                      height: 480,
                    };
                  }
                }
                var dataImg =
                  imageInfo != null
                    ? '" data-image-url="' +
                      imageInfo.src +
                      '" data-image-widths="[' +
                      supported_sizes +
                      ']" data-image-aspect-ratio="1" data-image-id="' +
                      imageInfo.id +
                      '"'
                    : "";
                var color_input_id = color_name + "-" + values.length;
                var variant_price = variant.price ? variant.price : 0;
                var variant_compare_at_price = variant.compare_at_price
                  ? variant.compare_at_price
                  : 0;
                var url_color = Utils.getFilePath(
                  Utils.slugify(value),
                  Globals.swatchExtension,
                  Settings.getSettingValue("general.swatchImageVersion")
                );
                itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
                itemSwatchHtml +=
                  '<input class="ColorSwatch__Radio" type="radio" ' +
                  checked +
                  ' name="' +
                  color_name +
                  '" id="' +
                  color_input_id +
                  '" value="' +
                  value +
                  '" data-image-aspect-ratio="' +
                  image_aspect_ratio +
                  '" data-variant-price="' +
                  variant_price +
                  '" data-variant-compare-at-price="' +
                  variant_compare_at_price +
                  '" data-variant-url="' +
                  Utils.buildProductItemUrl(data) +
                  "?variant=" +
                  variant.id +
                  "#Image" +
                  imageInfo.id +
                  '"' +
                  dataImg +
                  '  aria-hidden="true">';
                itemSwatchHtml +=
                  '<label class="ColorSwatch ColorSwatch--small" for="' +
                  color_input_id +
                  '" style="background-color: ' +
                  value.replace(" ", "").toLowerCase() +
                  "; background-image: url(" +
                  url_color +
                  ')" title="' +
                  value +
                  '" data-tooltip="' +
                  value +
                  '"></label>';
                itemSwatchHtml += "</div>";
                i++;
              }
            });
            itemSwatchHtml += "</div>";
          }
        });
      }
      return itemSwatchHtml;
    }
    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      if (!totalProduct) totalProduct = this.totalProduct;
      // Get page info
      var currentPage = parseInt(Globals.queryParams.page);
      var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

      if (totalPage > 1) {
        var paginationHtml = boostPFSTemplate.paginateHtml;
        // Build Previous
        var previousHtml =
          currentPage > 1
            ? boostPFSTemplate.previousActiveHtml
            : boostPFSTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, currentPage - 1)
        );
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml =
          currentPage < totalPage
            ? boostPFSTemplate.nextActiveHtml
            : boostPFSTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, currentPage + 1)
        );
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
          beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
          beforeCurrentPageArr.unshift("...");
        }
        if (currentPage - 4 >= 0) {
          beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (
          var iAfter = currentPage + 1;
          iAfter < currentPage + 3 && iAfter <= totalPage;
          iAfter++
        ) {
          afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
          afterCurrentPageArr.push("...");
        }
        if (currentPage + 3 <= totalPage) {
          afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = "";
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
          if (pageArr[iPage] == "...") {
            pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
          } else {
            pageItemsHtml +=
              pageArr[iPage] == currentPage
                ? boostPFSTemplate.pageItemSelectedHtml
                : boostPFSTemplate.pageItemHtml;
          }
          pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
          pageItemsHtml = pageItemsHtml.replace(
            /{{itemUrl}}/g,
            Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
          );
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
      }

      return "";
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
      var html = "";
      if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty("sortingHtml")) {
        var sortingArr = Utils.getSortingList();
        if (sortingArr) {
          var sortingItemsHtml = "";
          let col_handle = boostPFSAppConfig.general.collection_handle;

          for (var k in sortingArr) {
            var label = sortingArr[k];

            if (col_handle == "merchandise" || col_handle == "riedel") {
              if (
                label != "Price: Low to High" &&
                label != "Price: High to Low" &&
                label != "Bestseller"
              ) {
                continue;
              }
            }

            var isSelected = Globals.queryParams.sort == k;
            sortingItemsHtml += `
              <button 
                type="button" 
                class="popover__value-option group" 
                role="option" 
                data-value="${k}"
                value="${k}" 
                ${isSelected ? 'aria-selected="true"' : ""}
              >
                <span class="reversed-link">${label}</span>
              </button>
            `;

          }

          html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        }
      }
      return html;
    };

    // Build Sorting event
    ProductSorting.prototype.bindEvents = function () {
      var topSortingSelector = jQ(Selector.topSorting);
      topSortingSelector.find(".popover__value-option").click(function (e) {
        FilterApi.setParam("sort", jQ(this).data("value"));
        FilterApi.setParam("page", 1);
        FilterApi.applyFilter("sort");
        jQ('[aria-controls="sort-by-popover"]').trigger("click");
      });
    };
    /************************** END BUILD TOOLBAR **************************/

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function (data, eventType) {
      if (!data) data = this.data;
      if (!eventType) eventType = this.eventType;
      /**
       *  Call theme function
       *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
       *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
       *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

      if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
      bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
      bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
      }
      */
    };

    // Build additional elements
    FilterResult.prototype.afterRender = function (data, eventType) {
      if (!data) data = this.data;
      if (!eventType) eventType = this.eventType;

      scrollToTopFilter(eventType);

      // if(eventType == "filter"){
      //   scroll({
      //     top: 0,
      //     behavior: "smooth"
      //   });
      // }
    };

    // Scroll to Top After Filter or Clear All Filter
    var scrollEvent = true;
    function scrollToTopFilter(eventType) {
      var headerHeight = 150;
      if (jQ("#shopify-section-header").length > 0) {
        headerHeight = jQ("#shopify-section-header")[0].clientHeight;
        if (jQ(".breadcrumbs").length > 0) {
          headerHeight =
            headerHeight +
            jQ(".breadcrumbs")[0].clientHeight +
            100 /*100 = breadcrumbs margin top + breadcrumbs margin bottom*/;
        }
        if (jQ(".FlexboxIeFix").length > 0) {
          headerHeight = headerHeight + jQ(".FlexboxIeFix")[0].clientHeight;
        }
      }
      if (
        (eventType == "filter" ||
          eventType == "clearAll" ||
          eventType == "clear" ||
          eventType == "sort") &&
        scrollEvent &&
        Globals.queryParams.event_type !== "page"
      ) {
        scrollEvent = false;
        window.scrollTo({
          top: headerHeight,
          behavior: "smooth",
        });
        setTimeout(function () {
          scrollEvent = true;
        }, 3000);
      }
    }

    // Build Default layout
    Filter.prototype.errorFilterCallback = function () {
      var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        isSafari = /Safari/.test(navigator.userAgent),
        isBackButton =
          window.performance &&
          window.performance.navigation &&
          2 == window.performance.navigation.type;
      if (!(isiOS && isSafari && isBackButton)) {
        var self = this,
          url = window.location.href.split("?")[0],
          searchQuery =
            self.isSearchPage() && self.queryParams.hasOwnProperty("q")
              ? "&q=" + self.queryParams.q
              : "";
        window.location.replace(url + "?view=bc-original" + searchQuery);
      }
    };

    FilterApi.beforeCall = function (eventType, eventInfo) {
      /* Change the filter params before calling api */
      Globals.queryParams.sort_first = "extra_sort3";
      /* No need to return anything */
    };
  })();
}

/* AWM: available-only filter choices; preserve the unfiltered product grid. */
if (typeof boostPFSThemeConfig !== "undefined") {
  (function () {
    BoostPFS.inject(this);
    var awmFacetCache = new Map();
    var awmFacetStyle = document.createElement("style");
    awmFacetStyle.textContent = ".awm-unavailable-filter-value{display:none!important}";
    document.head.appendChild(awmFacetStyle);

    function awmFacetRequest() {
      var config = window.boostPFSConfig || {};
      var general = config.general || {};
      var query = Globals.queryParams || {};
      var params = new URLSearchParams();
      Object.keys(query).sort().forEach(function (key) {
        if (key.indexOf("pf_") !== 0 && ["q", "tag", "tag_mode", "h_options", "lang", "currency", "country", "collection_scope", "scope", "inventory_base_selected_locations"].indexOf(key) < 0) return;
        var value = query[key];
        if (value === null || value === undefined || value === "") return;
        (Array.isArray(value) ? value : [value]).forEach(function (entry) {
          params.append(Array.isArray(value) ? key + "[]" : key, String(entry));
        });
      });
      params.set("shop", Globals.shopDomain || "angry-wine-merchant.myshopify.com");
      if (!params.has("collection_scope")) params.set("collection_scope", general.collection_id || 0);
      params.set("product_available", "true");
      params.set("variant_available", "true");
      params.set("build_filter_tree", "true");
      params.set("zero_options", "false");
      params.set("page", "1");
      params.set("limit", "1");
      var endpoint = (config.api || {}).filterUrl || "https://services.mybcapps.com/bc-sf-filter/filter";
      return endpoint + "?" + params.toString();
    }

    function awmApplyAvailableValues(option, availableOptions) {
      if (!option || option.status !== "active" || !option.filterItems) return;
      var available = availableOptions.get(option.filterOptionId);
      if (!available || !Array.isArray(available.values)) return;
      var allowed = new Set(available.values.filter(function (value) {
        return Number(value.doc_count) > 0;
      }).map(function (value) { return String(value.key); }));
      var anyVisible = false;
      option.filterItems.forEach(function (item) {
        var visible = !!item.isSelected || allowed.has(String(item.value));
        anyVisible = anyVisible || visible;
        if (item.$element) item.$element.toggleClass("awm-unavailable-filter-value", !visible);
      });
      if (option.$element) option.$element.toggleClass("awm-unavailable-filter-value", !anyVisible);
    }

    function awmAvailableOptions(url) {
      var cached = awmFacetCache.get(url);
      if (cached && Date.now() - cached.created < 60000) return cached.promise;
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      var promise = fetch(url, { signal: controller.signal, credentials: "omit" }).then(function (response) {
        if (!response.ok) throw new Error("Availability filter request failed");
        return response.json();
      }).then(function (data) {
        if (!data.filter || !Array.isArray(data.filter.options)) throw new Error("Availability filter data missing");
        return new Map(data.filter.options.map(function (option) { return [option.filterOptionId, option]; }));
      }).catch(function (error) {
        awmFacetCache.delete(url);
        throw error;
      }).finally(function () { clearTimeout(timeout); });
      if (awmFacetCache.size >= 20) awmFacetCache.delete(awmFacetCache.keys().next().value);
      awmFacetCache.set(url, { created: Date.now(), promise: promise });
      return promise;
    }

    var awmOriginalTreeAfterRender = FilterTree.prototype.afterRender;
    FilterTree.prototype.afterRender = function () {
      if (awmOriginalTreeAfterRender) awmOriginalTreeAfterRender.apply(this, arguments);
      if (!Utils.isCollectionPage() || !this.filterOptions) return;
      var tree = this;
      var generation = (tree._awmAvailableGeneration || 0) + 1;
      tree._awmAvailableGeneration = generation;
      awmAvailableOptions(awmFacetRequest()).then(function (availableOptions) {
        if (tree._awmAvailableGeneration !== generation) return;
        tree._awmAvailableOptions = availableOptions;
        tree.filterOptions.forEach(function (option) { awmApplyAvailableValues(option, availableOptions); });
      }).catch(function (error) {
        console.warn("AWM available filter choices could not be refreshed; original choices retained.", error);
      });
    };

    var awmOriginalOptionAfterRender = FilterOption.prototype.afterRender;
    FilterOption.prototype.afterRender = function () {
      if (awmOriginalOptionAfterRender) awmOriginalOptionAfterRender.apply(this, arguments);
      if (this.parent && this.parent._awmAvailableOptions) {
        awmApplyAvailableValues(this, this.parent._awmAvailableOptions);
      }
    };
  })();
}
